@if (derrors && control?.errors) {
  <ul class="pr-errors">
    @for (
      controlError of Object.entries(control?.errors);
      track controlError[0]
    ) {
      <li>
        @if (controlError[0] == 'custom') {
          {{ control.errors.custom }}
        } @else {
          @if (dynamicErrors[controlError[0]]) {
            {{
              dynamicErrors[controlError[0]](
                controlError[1] ||
                  controlError[0]?.requiredLength ||
                  controlError[0]?.requiredPattern
              )
            }}
          } @else {
            @if (errors[controlError[0]]) {
              {{ errors[controlError[0]] }}
            } @else {
              {{ control.errors | json }}
            }
          }
        }
      </li>
    }
  </ul>
}
